import { Routes, Route, useLocation, useSearchParams } from "react-router-dom";
import { Header, TabNames } from "./components/Header/Header";
import { Footer } from "./components/Footer/Footer";
import { Contact } from "./components/Contact/Contact";
import { Home } from "./components/Home/Home";
import { Product } from "./components/Product/Product";
import { About } from "./components/About/About";
import { useEffect, useState } from "react";
import { MenuItemProps } from "semantic-ui-react";
import { Mobile } from "./components/MobileF/Mobile";
import ArrowUpwardOutlinedIcon from '@mui/icons-material/ArrowUpwardOutlined';
import CloseIcon from '@mui/icons-material/Close';
import "./App.css";
import { Demo } from "./components/Demo/Demo";
import config from "./config.js";
import MessageParser from "./MessageParser.jsx";
import ActionProvider from "./ActionProvider.jsx";
import Chatbot from "react-chatbot-kit";
import bot from "./images/bot.png";


export const App = () => {
  const [activeItem, setActiveItem] = useState<TabNames>(TabNames.HOME);
  const location = useLocation()

  const [navBg, setNavBg] = useState(true);

  const [showBot, toggleBot] = useState(false);
  const [isZoomingOut, setIsZoomingOut] = useState(false);


  const changeNavBg = () => {
      window.scrollY >= 150 ? setNavBg(true) : setNavBg(false);
     }
   
     useEffect(() => {
       window.addEventListener('scroll', changeNavBg);
       return () => {
         window.removeEventListener('scroll', changeNavBg);
       }
     }, []);
     const scrollToTop = () => {
      window.scrollTo(0,0);
     }

  const handleBotClick = () => {
    if (!showBot) {
      // If bot is not showing, trigger zoomout animation first
      setIsZoomingOut(true);
      setTimeout(() => {
        toggleBot(true);
        setIsZoomingOut(false);
      }, 600); // Match animation duration
    } else {
      // If bot is showing, just toggle it
      toggleBot(false);
    }
  }

  let [searchParams, setSearchParams] = useSearchParams();
  useEffect(() => {
    const pathname1 = location.pathname.split("?")[0];  
    console.log(pathname1,'ssssss');
          
    switch(pathname1) {
        case "/product":
            setActiveItem(TabNames.PRODUCTS);
            break;
            case "/mobile":
              setActiveItem(TabNames.MOBILE);
              break;
        case "/contact":
            setActiveItem(TabNames.CONTACT);
            break;
            case "/demo":
            setActiveItem(TabNames.DEMO);
            break;
        case "/about-us":
            setActiveItem(TabNames.ABOUT_US);
            break;
        default:
            setActiveItem(TabNames.HOME);
            break;
    }        
  }, [location.pathname])

  const handleItemClick = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, data: MenuItemProps) => {
    if (data.name) {
        setActiveItem(data.name as TabNames);
        console.log(data.name,TabNames.PRODUCTS,"namesssss");
        
        if (data.name === TabNames.PRODUCTS) 
        {
          setSearchParams({q:'Class_Student'})
        }
        
    }
  }

  return (
    <>
      <Header activeItem={activeItem} handleItemClick={handleItemClick} />
   
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/product" element={<Product />} />
          <Route path="/mobile" element={<Mobile />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/demo" element={<Demo />} />
          <Route path="/about-us" element={<About />} />
        </Routes>
      <Footer activeItem={activeItem} handleItemClick={handleItemClick}/>
      <ArrowUpwardOutlinedIcon className= {navBg ? ('Uparrow') : ('UparrowHiden')} onClick={scrollToTop}>
  
      </ArrowUpwardOutlinedIcon>

    {showBot && (
        
          <div className="app-chatbot-container">
            <Chatbot
              config={config}
              messageParser={MessageParser}
              actionProvider={ActionProvider}
            />
          </div>
        
      )}
    <button
          className="app-chatbot-button"
          onClick={handleBotClick}
        >
        {!showBot && (
            
          <div className="chatbot-text">Hey there If you need any <br></br>assistance, I'm here to help!</div>)}
          <div style={{backgroundColor:'#F5FAFB'}} className="app-chatbot-button-botbox">  
          {!showBot == true  ?  
             <img src={bot} alt='Q-bot'  style={{width: '100%', height: '100%',}} className={`bot-icon ${isZoomingOut ? 'zooming-out' : ''}`}/> : <CloseIcon className= 'close-icon'>
  
             </CloseIcon>}
             </div>
       
       
        </button>  
    </>
  );
}